import { createAsyncThunk } from "@reduxjs/toolkit";
import { update_user_address } from "../../../../api/calls/user/edit-user-address";
import { setMainModal } from "../../main";
import { editAddress } from "../address";
export const editAddressThunk = createAsyncThunk("address/edit_address_thunk", async (data, { dispatch, getState }) => {
    const response = await update_user_address(data);
    if (response.success) {
        if (!!response.content) {
            dispatch(editAddress(response.content));
        }
    }
    else {
        dispatch(setMainModal({ title: "Something went wrong while adding your address!", messages: [response.message] }));
    }
    return response;
});
